<template src='./Marcaciones.html'></template>
<script>
import Icono from "../Icono/Icono";

export default {
  components: {
    Icono
  },
  
  data() {
    return {
      botonSeleccionado: [],
      indexBoton: 0,
      botonGrande: false,
      botonMarca: false,
      invisible: false,
      visible: false,
      tieneMarcacion: false,
      noTieneMarcacion: false
    };
  },

  props: {
    informacionMarcaciones: {
      type: Array,
      required: true
    }
  },

  mounted() { 
    if (this.informacionMarcaciones.length > 0) {
      this.seleccionarBoton(this.botonSeleccionado, 0);
      }
  },

  methods: {
     seleccionarBoton (nombreBoton, indexBoton) {
      this.verMarcaciones = false;
      this.botonSeleccionado = nombreBoton;
      this.botonGrande = true;
      this.botonMarca = true;
      this.invisible = true;
      this.visible = true;
      this.indexBoton = indexBoton;
    },
  }
};
</script>
<style lang="scss" scoped src='./Marcaciones.scss'>
</style>


// WEBPACK FOOTER //
// src/components/Marcaciones/Marcaciones.vue